module.exports = __webpack_public_path__ + "img/适老化3.18a71b86.jpg";